<footer class="footer">
  <section class="footer-bottom" aria-label="Site footer">
    <div class="footer-container">
      <div class="footer-trademarks-wrapper">
        <p class="footer-trademarks-content">
          MOTOROLA, MOTO, MOTOROLA SOLUTIONS and the Stylized M Logo are trademarks or registered trademarks of Motorola<br />
          Trademark Holdings, LLC and are used under license. All other trademarks are the property of their respective owners.
        </p>
      </div>

      <ul class="footer-bottom-links">
        <li class="footer-copyright-wrap">
          <span class="footer-copyright-content">&copy; {{ currentYear }} Motorola Solutions, Inc. All rights reserved.</span>
        </li>
        <li><a href="/en_us/about/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Statement</a></li>
        <li><a href="/en_us/about/terms-use.html" target="_blank" rel="noopener noreferrer">Terms of Use</a></li>
        <li><a href="/en_us/about/cookie-policy.html">Cookie Preferences</a></li>
        <li><a href="/en_us/preference-center-form.html">Communication Preference</a></li>
        <li><a href="/en_us/about/accessibility.html">Accessibility</a></li>
        <li>
          <a href="https://moto.iad1.qualtrics.com/jfe/form/SV_bPfXVOgfrq5izgW" target="_blank" rel="noopener noreferrer">Site Feedback</a>
        </li>
        <li class="footer-region">
          <a class="footer-region-content" href="/content/msi/en_us" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
              <g fill="none" stroke="currentColor" stroke-linecap="square">
                <path d="M0 0h32v32H0z" stroke="none" />
                <g transform="translate(5 4)">
                  <path d="M11.4 21.9c-2-1.6-2.1-6.7 1-7.9 1.7-.7 2.2 3 5.5 2.1.6-.2 2 .6 1.5 2" />
                  <path d="M5.7 3.8c.6.5 1.1.9 1.6 1.7.4.7 1.3 2.6.5 3.7C6.8 10.5 4 10.9 4 12c0 .8 1.2 1.8 1.8 2.8 1 1.4.5 2.8 0 3.7-.3.5-.5.8-1 1" />
                  <path d="M21.4 10c.1.7.2 1.3.2 2 0 5.6-4.5 10.1-10.1 10.1S1.3 17.6 1.3 12 5.8 1.9 11.4 1.9c.5 0 .8 0 1.3.1" />
                  <path d="M20.5 3.9c0 2.5-4.1 6.1-4.1 6.1s-4.1-3.6-4.1-6.1c0-2.6 2.1-4.1 4.1-4.1s4.1 1.5 4.1 4.1z" />
                </g>
              </g>
            </svg>
            USA &amp; Canada
          </a>
        </li>
      </ul>
    </div>
  </section>
</footer>